import { DATE_PARAM_RE } from './date-param-pattern.js';

export function dateFromParam(value: string | undefined): Date | undefined {
  const match = value ? DATE_PARAM_RE.exec(value) : null;
  if (!match) return undefined;
  const [, year, month, day] = match.map(Number);
  const date = new Date(year!, month! - 1, day);
  return date.getFullYear() === year && date.getMonth() === month! - 1 && date.getDate() === day
    ? date
    : undefined;
}
